import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Approved library access for user',
  name: 'approved_library_access',
  params: [
    {
      description: 'The id of the library',
      name: 'library_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The id of the updated library member',
      name: 'library_member_id',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
